// extracted by mini-css-extract-plugin
export default {"shareDiv":"share-button_shareDiv__PvXbK","shareIconBtn":"share-button_shareIconBtn__dcBiY","shareButton":"share-button_shareButton__UQJRg","icon":"share-button_icon__sS22I"};